module.exports = __webpack_public_path__ + "templates.checkout-object-detail-b3989fe1.html";